import axios from 'axios';
import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
    url: process.env.VUE_APP_KEYCLOAK_URL,
    realm: process.env.VUE_APP_KEYCLOAK_REALM,
    clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID
});

const state = {
  user: null,
  timerId: null
};

const getters = {
  isAuthenticated: state => !!state.user,
  stateUser: state => state.user
};

const actions = {
  async logIn({dispatch}) {
    try {
        const authenticated = await keycloak.init({
            onLoad: 'login-required'
        });
        if (authenticated) {
          await dispatch('viewMe');
          await dispatch('initSocialstyrelsenGeneric');
          if (state.timerId) {
            clearInterval(state.timerId);
          }
          state.timerId = setInterval(() => {
            dispatch('refreshToken');
          }, 60000);
        }
        console.log(`User is ${authenticated ? 'authenticated' : 'not authenticated'}`);
    } catch (error) {
        console.error('Failed to initialize adapter:', error);
    }
  },
  async viewMe({commit}) {
    let {data} = await axios.get('users/whoami', { headers: { Authorization: `Bearer ${keycloak.token}` } });
    data.keycloak_token = keycloak.token;
    await commit('setUser', data);
    return data;
  },
  async refreshToken({dispatch}) {
    return await refreshTokenInternal(120).then(refreshed => {
      if (refreshed) {
        console.log('Keycloak token refreshed');
        return dispatch('viewMe');
      } else {
        console.log('Keycloak token not refreshed, valid for another ' + computeTokenSecondsLeft() + ' seconds');
      }
    });
  },
  async forceRefreshToken({dispatch}) {
    return await refreshTokenInternal(computeTokenSecondsLeft() + 60).then(refreshed => {
      if (!refreshed) {
        throw new Error('Failed to force refresh Keycloak token');
      }
    }).then(() => {
        return dispatch('viewMe');
    });
  },
  async logOut({commit}) {
    if (state.timerId) {
      clearInterval(state.timerId);
    }
    await keycloak.logout()
    let user = null;
    commit('logout', user);
  }
};

function computeTokenSecondsLeft() {
  return Math.max(0, Math.floor(keycloak.tokenParsed.exp + keycloak.timeSkew - (new Date().getTime() / 1000)));
}

async function refreshTokenInternal(minValidity) {
  return keycloak.updateToken(minValidity).catch(error => {
    console.error('Failed to refresh Keycloak token: ', error);
    return false;
  });
}

const mutations = {
  setUser(state, user) {
    state.user = user;
  },
  logout(state, user){
    state.user = user;
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};
